import { render, staticRenderFns } from "./CurvedBar.vue?vue&type=template&id=f0ccbaf0&scoped=true"
import script from "./CurvedBar.vue?vue&type=script&lang=js"
export * from "./CurvedBar.vue?vue&type=script&lang=js"
import style0 from "./CurvedBar.vue?vue&type=style&index=0&id=f0ccbaf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0ccbaf0",
  null
  
)

export default component.exports